export default {
  currentUser: 'USER_GETTERS_CURRENTUSER',
  getToken: 'USER_GETTERS_GETTOKEN',
  signedIn: 'USER_GETTERS_GETSIGNEDIN',
  localeCode: 'USER_GETTERS_LOCALE_CODE'
}
